import { useEffect } from "react";
import { useState } from "react";
import { Modal, Button } from "react-bootstrap";
import { FeeRule } from "../../../../models";

import { StringDetailedResponse } from "../../../../models/swagger/generated-submission-service";
import { FeeRuleService } from "../../../../services/ClientService";

export type FeeRuleTestModalProps = {
    show: boolean;
    attorneyId?: string;
    county?: string;
    division?: string;
    ruleId?: string;
    filename?: string;
    fileText?: string;
    documentType?: string;
    feeName?: string;
    data?: FeeRule;
    onSubmit: () => void;
    onClose: () => void;
};

export default function FeeRuleTestModal({
    show,
    attorneyId,
    county,
    division,
    ruleId,
    filename,
    fileText,
    documentType,
    feeName,
    onSubmit,
    onClose,
}: FeeRuleTestModalProps) {
    const [rule, setRule] = useState({
        id: ruleId,
        attorneyID: attorneyId,
        county: county,
        division: division,
        filename: filename,
        fileText: fileText,
        documentType: documentType,
        feeName: feeName,
    } as FeeRule);

    const [data, setData] = useState("");

    useEffect(() => {
        setRule({
            id: ruleId,
            attorneyID: attorneyId,
            county: county,
            division: division,
            filename: filename,
            fileText: fileText,
            documentType: documentType,
            feeName: feeName,
        });
    }, [
        show,
        attorneyId,
        county,
        division,
        document,
        ruleId,
        filename,
        fileText,
        documentType,
        feeName,
    ]);

    const submitRule = () => {
        FeeRuleService.getRule({
            body: {
                ...rule,
            },
        }).then(
            (resp) => {
                //onSubmit();
                setData(JSON.stringify(resp.data));
            },
            (error) => {
                console.log(error);
            }
        );
    };

    const closeWindow = () => {
        setData("");
        onClose();
    };

    return (
        <Modal
            show={show}
            size="lg"
            aria-labelledby="contained-modal-title-vcenter"
            centered
        >
            <Modal.Header>
                <Modal.Title id="contained-modal-title-vcenter">
                    Fee Rule
                </Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <div className="row form-group m-2">
                    <div className="col-sm-6">
                        <label>Attorney ID</label>
                        <input
                            className="form-control"
                            id="feeRuleAttorneyID"
                            type="text"
                            defaultValue={rule.attorneyID}
                            onChange={(event) =>
                                setRule({
                                    ...rule,
                                    attorneyID: event.currentTarget.value,
                                })
                            }
                        />
                    </div>
                    <div className="col-sm-6">
                        <label>County</label>
                        <input
                            className="form-control"
                            id="feeRuleCounty"
                            type="text"
                            defaultValue={rule.county}
                            onChange={(event) =>
                                setRule({
                                    ...rule,
                                    county: event.currentTarget.value,
                                })
                            }
                        />
                    </div>

                    <div className="col-sm-6">
                        <label>Division</label>
                        <input
                            className="form-control"
                            id="feeRuleDivision"
                            type="text"
                            defaultValue={rule.division}
                            onChange={(event) =>
                                setRule({
                                    ...rule,
                                    division: event.currentTarget.value,
                                })
                            }
                        />
                    </div>
                </div>

                <div className="row form-group m-2">
                    <div className="col-sm-12">
                        <label>Filename</label>
                        <input
                            className="form-control"
                            id="feeRuleFilename"
                            type="text"
                            defaultValue={rule.filename}
                            onChange={(event) =>
                                setRule({
                                    ...rule,
                                    filename: event.currentTarget.value,
                                })
                            }
                        />
                    </div>
                </div>

                <div className="row form-group m-2">
                    <div className="col-sm-12">
                        <label>File Text</label>
                        <input
                            className="form-control"
                            id="feeRuleFileText"
                            type="text"
                            defaultValue={rule.fileText}
                            onChange={(event) =>
                                setRule({
                                    ...rule,
                                    fileText: event.currentTarget.value,
                                })
                            }
                        />
                    </div>
                </div>

                <div className="row form-group m-2">
                    <div className="col-sm-12">
                        <label>Fee Name</label>
                        <input
                            className="form-control"
                            id="feeRuleFeeName"
                            type="text"
                            defaultValue={rule.feeName}
                            onChange={(event) =>
                                setRule({
                                    ...rule,
                                    feeName: event.currentTarget.value,
                                })
                            }
                        />
                    </div>
                </div>

                <div className="row form-group m-2">
                    <div className="col-sm-12">
                        <label>Document Type</label>
                        <input
                            className="form-control"
                            id="feeRuleDocType"
                            type="text"
                            defaultValue={rule.documentType}
                            onChange={(event) =>
                                setRule({
                                    ...rule,
                                    documentType: event.currentTarget.value,
                                })
                            }
                        />
                    </div>
                </div>
                <div className="row form-group m-2">
                    <div className="col-sm-12">
                        <label>Result:</label>
                        <label>{data}</label>
                    </div>
                </div>
            </Modal.Body>
            <Modal.Footer>
                <Button className="btn-danger" onClick={closeWindow}>
                    Cancel
                </Button>
                <Button onClick={submitRule}>Submit</Button>
            </Modal.Footer>
        </Modal>
    );
}
